const categoryOptions = [
  {
    index: 0,
    category: 'shower',
    title: "Shower",
  },
  {
    index: 1,
    category: 'flush',
    title: "Flush",
  },
  {
    index: 2,
    category: 'dishes',
    title: "Dishes",
  },
  {
    index: 3,
    category: 'carWash',
    title: "CarWash",
  },
  {
    index: 4,
    category: 'laundry',
    title: "Laundry",
  },
  {
    index: 5,
    category: 'eatingOut',
    title: "EatingOut",
  },
  {
    index: 6,
    category: 'washHands',
    title: "WashingHands",
  },
  {
    index: 7,
    category: 'bath',
    title: "Bath",
  },
  {
    index: 8,
    category: 'other',
    title: "Other",
  },
  {
    index: 9,
    category: 'all',
    title: "All",
  }
];

export default categoryOptions
